@let eppConfigValue = egpConfig();
@let isLoadingValue = isLoading();
@let egpDataValue = egpData();

@if (eppConfigValue && !isLoadingValue) {
  <div
    class="dashboard-egp egp-card-wrapper"
    [class.dashboard-egp-with-text]="eppConfigValue.view === 'text'">
    <div class="dashboard-egp-riskbox-zone">
      <div
        [id]="'svg' + eppConfigValue.region"
        class="risk-card__riskgraphic-container"
        [ngStyle]="{ display: isLoadingValue ? 'none' : 'unset' }"></div>

      @if (egpDataValue) {
        <app-riskbox
          [riskBoxdata]="egpDataValue.matrices[0]"
          [svgid]="'svg' + eppConfigValue.region"
          [mini]="false"
          [season]="eppConfigValue['season']"></app-riskbox>
      } @else {
        <div class="dashboard-egp__no-data-info">
          <fa-icon [icon]="['far', 'align-slash']" [size]="'4x'"></fa-icon>
          <p>{{ 'PRODUCT.EGP.NO_EGP_INFO' | translate }}</p>
        </div>
      }
    </div>

    @if (egpDataValue && eppConfigValue.view === 'text') {
      @let day = 0;
      @let fcstTime =
        {
          summer: '8',
          winter: '10',
        };
      @let forecastForSeasonTranslation =
        'PRODUCT.EGP.forecast.' + eppConfigValue.season | translate;
      @let amTranslation = 'PRODUCT.EGP.am' | translate;
      @let untilTranslation = 'PRODUCT.EGP.until' | translate;
      @let fcstTimeForSeason = fcstTime[eppConfigValue.season];
      @let wday = egpDataValue | wDay: day;
      @let title =
        wday
          | title
            : day
            : fcstTimeForSeason
            : forecastForSeasonTranslation
            : amTranslation
            : untilTranslation;

      <div class="dashboard-egp-text-zone">
        @if (egpDataValue.textObject?.texts?.[day]) {
          <h3 class="dashboard-egp-text-title">
            {{ title }}
          </h3>

          <div class="dashboard-egp-text-content">
            @for (
              textline of egpDataValue.textObject.texts[0].text.split('\n');
              track $index
            ) {
              <p>{{ textline }}</p>
            }
          </div>
        }
      </div>
    }

    @if (egpDataValue && showUpdatedChip()) {
      <div class="dashboard-updated-chip-egp">
        <fa-icon [icon]="['far', 'clock']"></fa-icon>
        @let langSignalValue = languageService.langSignal();
        {{
          egpDataValue['textObject']['prescribeAt']
            | datex: 'DD.MM. HH:mm' : undefined : langSignalValue
        }}
      </div>
    }
  </div>
} @else {
  <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
  </app-loading-overlay>
}
